import React from 'react';
import { Box } from '@mui/material';
import LandingNav from '../components/landing/LandingNav';
import HeroSection from '../components/landing/HeroSection';
import TrustStrip from '../components/landing/TrustStrip';
import HowItWorks from '../components/landing/HowItWorks';
import MessageExamples from '../components/landing/MessageExamples';
import GroupsSection from '../components/landing/GroupsSection';
import EverydayFeatures from '../components/landing/EverydayFeatures';
import DashboardPreview from '../components/landing/DashboardPreview';
import PrivacySection from '../components/landing/PrivacySection';
import WhatsAppSoon from '../components/landing/WhatsAppSoon';
import PricingSection from '../components/landing/PricingSection';
import LandingFaq from '../components/landing/LandingFaq';
import FinalCta from '../components/landing/FinalCta';
import LandingFooter from '../components/landing/LandingFooter';
import { landing } from '../components/landing/tokens';

/** The public page: Fin, the assistant, for personal money and for groups. */
const LandingPage: React.FC = () => (
  <Box
    sx={{
      minHeight: '100vh',
      bgcolor: landing.bg,
      color: landing.ink,
      fontFamily: landing.body,
      fontSize: 16,
      lineHeight: 1.5,
      '& h1, & h2, & h3': {
        fontFamily: landing.display,
        m: 0,
        textWrap: 'balance',
      },
      '& p': { m: 0, textWrap: 'pretty' },
      '& a:focus-visible, & button:focus-visible': {
        outline: `2px solid ${landing.accent}`,
        outlineOffset: '3px',
      },
    }}
  >
    <LandingNav />
    <Box component='main'>
      <HeroSection />
      <TrustStrip />
      <HowItWorks />
      <MessageExamples />
      <GroupsSection />
      <EverydayFeatures />
      <DashboardPreview />
      <PrivacySection />
      <WhatsAppSoon />
      <PricingSection />
      <LandingFaq />
      <FinalCta />
    </Box>
    <LandingFooter />
  </Box>
);

export default LandingPage;
